import React, { useState, useRef } from "react";
import "./createLegalDoc.css";
import GoogleButton from "../components/GoogleAuth";
import { logEvent } from "firebase/analytics";
import { config } from "../config";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FullScreenLoader from "../components/FullScreenLoader";
import { Helmet } from "react-helmet-async";
import LeftPanel from "../components/leftPanel";
import { analytics } from "../components/firebase";
const NonCriminalCertificat = () => {
  const googleAuthRef = useRef(null);
  const [applicantName, setApplicantName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [identificationDetails, setIdentificationDetails] = useState("");
  const [reasonForCertificate, setReasonForCertificate] = useState("");
  const [jurisdiction, setJurisdiction] = useState("");
  const [language, setLanguage] = useState("English");
  const [errors, setErrors] = useState({});
  const [popupMessage] = useState("");
  const [isPopupVisible] = useState(false);
  const textAreaRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);

  const navigate = useNavigate();
  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]);

  console.log("✅ Create page loaded!");
  const location = useLocation();

  const initialText = location.state?.text || "";
  const receivedKey = location.state?.key || "Legal Document";
  const [Topic, setTopic] = useState(initialText);
  const [Keypoints, setKeypoints] = useState("");

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleGenerate = async () => {
    setIsLoading(true);
    setIsButtonVisible(false);
    document.body.classList.add("no-scroll");

    try {
      const requestData = {
        applicantName,
        dateOfBirth,
        identificationDetails,
        reasonForCertificate,
        jurisdiction,
        selectedLanguage: language,
      };
      logEvent(analytics, "generate_button_click", {
        action: "Generate Non  Criminal Certificate Document",
        topic: Topic,
      });

      const generationResponse = await fetch(`${config.baseURL}/noc_gen.php`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const rawResponse = await generationResponse.text();
      let data;

      try {
        data = JSON.parse(rawResponse);
      } catch {
        toast.error("Please re-try after some time");
        return;
      }

      if (data.error) {
        if (data.error === "Authentication failed") {
          googleAuthRef.current?.login();
          return;
        }
        if (data.redirect === "premium") {
          navigate(`/premium?id=${data.premiumId}`);
          return;
        }
        toast.error("Please re-try after some time");
        return;
      }

      if (data.success && data.resultText) {
        navigate("/result", {
          state: { result: data.resultText, history_id: data.history_id },
        });
        setApplicantName("");
        setDateOfBirth("");
        setIdentificationDetails("");
        setReasonForCertificate("");
        setJurisdiction("");
        setLanguage("English");
      } else {
        toast.error("Please re-try after some time");
      }
    } catch (error) {
      toast.error("Please re-try after some time");
      logEvent(analytics, "error", {
        error_type: "api_call_failed",
        error_message: "Failed to generate document due to API error.",
        action: "generate_button_click",
      });
    } finally {
      setIsLoading(false);
      document.body.classList.remove("no-scroll");
    }
  };

  const handleLoginSuccess = (userData) => {
    toast.success("Logged in – go ahead and click Generate again!");
  };

  const handleLoginFailure = () => {};

  return (
    <div className="create_background">
       <Helmet key="landing">
       <title>
    Generate Non-Criminal Certificate Online | AI Legal Document Generator
  </title>

  <meta
    name="description"
    content="Create a Non-Criminal Certificate easily with our AI-powered legal document generator. Fill in your details like full name, DOB, ID number, and reason, and get a professionally formatted certificate tailored to your jurisdiction."
  />

  <meta
    name="keywords"
    content="non-criminal certificate generator, non-criminal affidavit form, create non-criminal record certificate, AI legal certificate generator, online background check certificate, non-conviction certificate form, no criminal record document, legal document automation, customizable legal forms online, non-criminal declaration form, character certificate generator"
  />
      
              <link rel="canonical" href="https://legaldocumentgenerator.com/non-criminal-certificate-templates" />
            </Helmet>
      {isLoading && <FullScreenLoader />}
      {isPopupVisible && (
        <div className="popup-notification">
          <p>{popupMessage}</p>
        </div>
      )}

      <LeftPanel />
      <div className="create_main_templates">
        <div className="create_title">
                  <img src={config.Backbutton} alt="back" onClick={handleBackClick} />
                  Create AI Legal Document
                </div>
        <div className="create_form_grid">
          <div className="create_inputbox1">
            Applicant's full name
            <textarea
              c
              className={`textarea_input ${
                errors.applicantName ? "error" : ""
              }`}
              placeholder="e.g., John Smith"
              value={applicantName}
              onChange={(e) => setApplicantName(e.target.value)}
              maxLength={1000}
            ></textarea>
            {errors.applicantName && (
              <div className="error-message">{errors.applicantName}</div>
            )}
          </div>

          <div className="create_inputbox1">
            Date of birth
            <textarea
              className={`textarea_input ${errors.dateOfBirth ? "error" : ""}`}
              placeholder="YYYY-MM-DD"
              value={dateOfBirth}
              onChange={(e) => setDateOfBirth(e.target.value)}
              maxLength={1000}
            ></textarea>
            {errors.dateOfBirth && (
              <div className="error-message">{errors.dateOfBirth}</div>
            )}
          </div>

          <div className="create_inputbox1">
            identification details(e.g., passport or ID number)
            <textarea
              className={`textarea_input ${
                errors.identificationDetails ? "error" : ""
              }`}
              placeholder="Passport or National ID number"
              value={identificationDetails}
              onChange={(e) => setIdentificationDetails(e.target.value)}
              maxLength={1000}
            ></textarea>
            {errors.identificationDetails && (
              <div className="error-message">
                {errors.identificationDetails}
              </div>
            )}
          </div>

          <div className="create_inputbox1">
            Reason for requesting the certificate
            <textarea
              className={`textarea_input ${
                errors.reasonForCertificate ? "error" : ""
              }`}
              placeholder="Purpose of this certificate"
              value={reasonForCertificate}
              onChange={(e) => setReasonForCertificate(e.target.value)}
              maxLength={1000}
            ></textarea>
            {errors.reasonforcertificate && (
              <div className="error-message">{errors.reasonforcertificate}</div>
            )}
          </div>

          <div className="create_inputbox1">
            Jurisdiction of the certificate
            <textarea
              className={`textarea_input ${errors.jurisdiction ? "error" : ""}`}
              placeholder="Country or State"
              value={jurisdiction}
              onChange={(e) => setJurisdiction(e.target.value)}
              maxLength={1000}
            ></textarea>
            {errors.jurisdiction && (
              <div className="error-message">{errors.jurisdiction}</div>
            )}
          </div>

          <div>
            <div className="create_inputbox1">Select Language</div>
            <select
              className="text_input"
              name="language"
              id="language"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="English">English</option>
              <option value="Arabic">Arabic (RTL)</option>
              <option value="Bulgarian">Bulgarian</option>
              <option value="Chinese">Chinese (Simplified)</option>
              <option value="French">French</option>
              <option value="German">German</option>
              <option value="Hebrew">Hebrew (RTL)</option>
              <option value="Hindi">Hindi</option>
              <option value="Indonesian">Indonesian</option>
              <option value="Italian">Italian</option>
              <option value="Japanese">Japanese</option>
              <option value="Portuguese">Portuguese</option>
              <option value="Punjabi">Punjabi</option>
              <option value="Russian">Russian</option>
              <option value="Spanish">Spanish</option>
              <option value="Swahili">Swahili</option>
              <option value="Tagalog">Tagalog</option>
              <option value="Urdu">Urdu</option>
            </select>
          </div>
        </div>
        <ToastContainer />
        <GoogleButton
          id="loginHidden"
          ref={googleAuthRef}
          onLoginSuccess={handleLoginSuccess}
          onLoginFailure={handleLoginFailure}
        />
        <button
          className="generate_btn"
          alt="Generate"
          onClick={handleGenerate}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default NonCriminalCertificat;
